import { gql } from "graphql-request";

const GetBankAccountsBusinessQuery = gql`
  query GetBankAccountsBusiness($businessId: ID!) {
    GetBankAccountsBusiness(businessId: $businessId) {
      Banks {
        id
        name
        regulatoryInstitutionCode
      }
      Currencies {
        id
        title
      }
      accountIdentifier
      accountType
      id
    }
  }
`;
export default GetBankAccountsBusinessQuery;
